import { useThemeStore } from '@/stores/themeStore';

interface SidebarLogoProps {
  /** Force the flame mark instead of the full horizontal lockup. */
  collapsed?: boolean;
}

/**
 * Merkflow brand lockup for navigation chrome.
 *
 * Uses the clean SVGs in `frontend/public/`:
 *   - `/merkflow-flame.svg`            — flame only, transparent (both modes)
 *   - `/merkflow-horizontal-dark.svg`  — white "merk" + orange "flow", no bg
 *   - `/merkflow-horizontal-light.svg` — dark "merk" + orange "flow", no bg
 */
export function SidebarLogo({ collapsed = false }: SidebarLogoProps) {
  const theme = useThemeStore((s) => s.theme);

  if (collapsed) {
    return <img src="/merkflow-flame.svg" alt="Merkflow" className="h-8 w-auto flex-shrink-0" />;
  }

  return (
    <img
      src={theme === 'dark' ? '/merkflow-horizontal-dark.svg' : '/merkflow-horizontal-light.svg'}
      alt="Merkflow"
      className="h-7 w-auto flex-shrink-0"
    />
  );
}
